import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import { Bezel } from '#src/atoms/ui/bezels/Bezel/index.tsx';

const StyledBezel = styled(Bezel)`
  padding: var(--intermediate-unit) var(--double-unit);
`;
export const FixtureOverviewBezel = ({
  rgbColor,
  ...rest
}: {
  rgbColor?: string | null;
  children: React.ReactNode;
}) => {
  return (
    <StyledBezel
      style={{ '--c-rgb-color': rgbColor } as CSSProperties}
      background="radial-gradient(46% 60% at 50% 100%,rgba(var(--c-rgb-color), 0.3) 5%, transparent 100%), conic-gradient(from 90deg at 3px 3px, var(--c-nd-50) 25%, transparent 0) 0 0/5px 5px, rgba(0, 0, 0, 0.5)"
      borderColor="linear-gradient(to bottom, var(--c-nd-100) 80%, rgba(var(--c-rgb-color), 1) 100%)"
      {...rest}
    />
  );
};
export const InlineFixtureOverviewBezel = styled(FixtureOverviewBezel)`
  display: flex;
  flex: 1;
  justify-content: center;
  min-width: 33%;
`;
